'use client';

import { PropsWithChildren, useState } from 'react';
import { VariantProps } from 'tailwind-variants';
import { tooltipStyles } from './styles';

interface ITooltipProps extends VariantProps<typeof tooltipStyles.content> {
  active?: boolean;
  message?: string;
}

export function Tooltip({
  active = true,
  children,
  design = 'secondary',
  message = 'Your tooltip message goes here',
  position = 'bottom-right',
  size,
}: PropsWithChildren<ITooltipProps>) {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  const handleMouseAction = (value: boolean) => {
    if (active) {
      setIsOpened(value);
    }
  };

  return (
    <div
      className={tooltipStyles.root()}
      onMouseEnter={() => handleMouseAction(true)}
      onMouseLeave={() => handleMouseAction(false)}
    >
      {children}
      <div
        className={tooltipStyles.container({
          position,
        })}
      >
        <div
          className={tooltipStyles.content({
            design,
            isOpened,
            position,
            size,
          })}
        >
          <span>{message}</span>
        </div>
      </div>
    </div>
  );
}
